export const getUniqueElements = <T>(arr: T[]): T[] => {
  const uniqueArr: T[] = [];

  for (const item of arr) {
    if (!uniqueArr.includes(item)) {
      uniqueArr.push(item);
    }
  }

  return uniqueArr;
};
